import React from "react";
import { useNavigate } from "react-router-dom";

export default function CartPopup({ cartItems, setCartItems, onClose }) {
  const navigate = useNavigate();

  const handleIncrease = (id) => {
    const updated = cartItems.map(item =>
      item.id === id ? { ...item, quantity: item.quantity + 1 } : item
    );
    setCartItems(updated);
  };

  const handleDecrease = (id) => {
    const updated = cartItems.map(item =>
      item.id === id ? { ...item, quantity: Math.max(1, item.quantity - 1) } : item
    );
    setCartItems(updated);
  };

  const subtotal = cartItems.reduce((acc, item) => acc + item.price * item.quantity, 0);

  return (
    <div style={{
      position:"absolute",
      top:0,
      right:0,
      width:"400px",
      height:"100%",
      background:"#fff",
      borderLeft:"1px solid #ccc",
      padding:"20px",
      overflowY:"auto",
      zIndex:1000,
      boxShadow:"-4px 0 10px rgba(0,0,0,0.2)"
    }}>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"20px" }}>
        <h3>Your Cart ({cartItems.length} {cartItems.length === 1 ? "item" : "items"})</h3>
        <button onClick={onClose} style={{ border:"none", background:"transparent", fontSize:"20px", cursor:"pointer" }}>×</button>
      </div>

      {cartItems.map(item => (
        <div key={item.id} style={{ display:"flex", marginBottom:"15px", gap:"10px" }}>
          <img src={item.imageUrl} alt={item.name} style={{ width:"60px", height:"60px", objectFit:"cover" }} />
          <div style={{ flex:1 }}>
            <div>{item.name}</div>
            <div>₹{item.price} x {item.quantity} = ₹{item.price * item.quantity}</div>
            <div style={{ display:"flex", gap:"5px", marginTop:"5px" }}>
              <button onClick={()=>handleDecrease(item.id)}>-</button>
              <span>{item.quantity}</span>
              <button onClick={()=>handleIncrease(item.id)}>+</button>
            </div>
          </div>
        </div>
      ))}

      <div style={{ fontWeight:"bold", marginTop:"20px" }}>Subtotal: ₹{subtotal}</div>

      <button
        style={{ width:"100%", padding:"10px", background:"#1b7a1b", color:"#fff", border:"none", borderRadius:"6px", marginTop:"15px", cursor:"pointer" }}
        onClick={()=>navigate("/checkout")}
      >
        Place Order
      </button>
    </div>
  );
}
